<template>
  <div class="login-page">
    <!-- 登录卡片 -->
    <div class="login-card">
      <div class="login-title">{{ title }}</div>
      <slot/>
    </div>
    
    <!-- 底部版权 -->
    <div class="login-footer">
      <div class="copyright">
        Copyright© {{ year }} 广州市佩升前研市场信息咨询有限公司, all rights reserved | 
        <a href="https://beian.miit.gov.cn" target="_blank" rel="nofollow">粤ICP备13010661号</a>
      </div>
    </div>
    
    <!-- 遮罩层 - 覆盖右下角水印 -->
    <div class="watermark-cover"></div>
  </div>
</template>

<script>
import { getYear, addClass, removeClass } from '@/utils'
export default {
  name: 'LoginLayout',

  props: {
    title: {
      type: String,
      default: '登录'
    }
  },
  
  data () {
    return {
      year: getYear()
    }
  },

  created () {
    addClass(document.body, 'login-page-body')
  },

  beforeDestroy () {
    removeClass(document.body, 'login-page-body')
  }
}
</script>

<style lang="scss">
/* 全局body样式 - 使用背景图 */
.login-page-body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: url('~@/assets/images/pc_logobg.png') no-repeat center center;
  background-size: cover;
  overflow: hidden;
}

/* 链接样式 */
a {
  color: #5a6a85;
  text-decoration: none !important;
  &:hover {
    color: #2b7cff;
  }
}

/* 登录页面容器 */
.login-page {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}

/* 登录卡片 */
.login-card {
  position: relative;
  z-index: 10;
  width: 380px;
  background: white;
  border-radius: 16px;
  padding: 40px 45px;
  box-shadow: 
    0 25px 80px rgba(0, 0, 0, 0.08),
    0 10px 30px rgba(0, 0, 0, 0.05);
  margin-left: -350px;
}

/* 登录标题 */
.login-title {
  font-size: 28px;
  font-weight: 600;
  color: #1a2a4a;
  margin-bottom: 35px;
  letter-spacing: 1px;
}

/* 底部版权 */
.login-footer {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 20;
  
  .copyright {
    font-size: 12px;
    color: #8a96a8;
  }
}

/* 遮罩层 - 覆盖右下角水印 */
.watermark-cover {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 120px;
  height: 40px;
  background: linear-gradient(135deg, #d8dfe8 0%, #cdd5e0 50%, #c8d0dc 100%);
  z-index: 5;
}

/* 响应式适配 */
@media (max-width: 900px) {
  .login-card {
    margin-left: 0;
  }
}
</style>
